import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getEventConfigs } from '@state/event';
import { getKioskEnabled } from '@state/kiosk';

const Image = styled.img`
  max-width: 100%;
  min-height: 0;
  max-height: 100%;
`;

export const SponsorImage = () => {
  const { badgePrintingImage } = useSelector(getEventConfigs);
  const isKiosk = useSelector(getKioskEnabled);

  if (!isKiosk || !badgePrintingImage) {
    return null;
  }

  return <Image src={badgePrintingImage.fullSizeUrl} alt="" />;
};
